import {
  chain,
} from 'lodash'

import { challengeStatus } from '@/services/challengeStatus.enum'

export function computeUserScore(questions) {
  return chain(questions)
    .map(question => {
      if (question.status === challengeStatus.SOLVED) {
        return question.score
      }
      return 0
    })
    .reduce((result, value) => result + value)
    .value()
}



// WEBPACK FOOTER //
// ./src/services/user.js